import * as React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';

export const SlideOver = ({ open, onOpenChange, title, children, width = 'w-full max-w-2xl' }) => {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/50 z-50" />
        <Dialog.Content className={`fixed top-0 right-0 bottom-0 z-50 ${width} bg-[var(--ds-surface-panel)] border-l border-[var(--ds-border-subtle)] shadow-[var(--ds-shadow-popover)] transform transition-transform duration-300 ease-out data-[state=open]:translate-x-0 data-[state=closed]:translate-x-full overflow-hidden flex flex-col`}>
          {/* Header */}
          <div className="px-6 py-4 border-b border-[var(--ds-border-divider)] flex items-center justify-between">
            {title && (
              <Dialog.Title className="text-lg font-semibold text-[var(--ds-text-primary)]">
                {title}
              </Dialog.Title>
            )}
            <Dialog.Close asChild>
              <button
                className="p-1.5 text-[var(--ds-text-muted)] hover:text-[var(--ds-text-primary)] hover:bg-[var(--ds-control-field-hover-bg)] rounded-md transition-colors"
                aria-label="Close"
              >
                <X className="h-5 w-5" />
              </button>
            </Dialog.Close>
          </div>
          
          {/* Content */}
          <div className="px-6 py-4 overflow-y-auto flex-1">
            {children}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default SlideOver;

